"use strict";

module.exports = {
  ETH_DERIVATION_PATH: "m/44'/60'/0'/0",
  ACCOUNT_INDEX: '0'
};